$(function() {

	// 產品介紹內頁-產品輪播
	if ( $('#productSlider').length != 0 ) {
		// 產品縮圖輪播
		var productThumbsSlider = new Swiper("#productThumbsSlider", {
			direction: 'vertical',
			observer: true, 
			observeParents: true,
			spaceBetween: 10,
			slidesPerView: 7,
			freeMode: true,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			breakpoints: {
				0: {
					direction: 'horizontal',
					slidesPerView: 4,
				},
				641: {  // >= 641
					direction: 'horizontal',
					slidesPerView: 5,
				},
				801: {  // >= 801
					direction: 'vertical',
					slidesPerView: 7,
				},
			},
		});
		// 產品大圖輪播
		var productSlider = new Swiper("#productSlider", {
			observer: true, 
			observeParents: true,
			thumbs: {
				swiper: productThumbsSlider,
			},
		});
	}

});